

import React from 'react';
import { Card, CardProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LinkProps } from 'react-router-dom';

type AnchorProps = {
  component?:
    | React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>>
    | undefined;
  to?: string;
  target?: string;
  rel?: string;
};

type HLCardProps = CardProps & AnchorProps;

const StyledCard = styled(Card)<HLCardProps>(() => ({
  borderRadius: 12,
  border: '1px solid #E9E9E9',
  boxShadow: 'none',
  textDecoration: 'none',
  '&[href]': {
    textDecoration: 'none',
    color: 'inherit',
  },
}));

function HLCard(props: HLCardProps) {
  return <StyledCard {...props} />;
}

export default HLCard;
